module.exports = __webpack_public_path__ + "img/salsa_1394.bf710687.jpg";